import { AxiosError, AxiosInstance, AxiosResponse, isAxiosError } from 'axios';
import { Path } from 'core/constants/path.constants';
import { EServicesErrorCode } from 'core/model/enums/error-code.enum';
import { IMaintenanceError } from 'core/model/interfaces/error.interface';
import { getMaintenanceErrorHandler, getNavigate } from 'shared/utils/maintenance.utils';

const createMaintenanceResInterceptor = (
  axiosClient: AxiosInstance,
  interceptorSuccess: (value: AxiosResponse<any>) => AxiosResponse<any>,
) => {
  const interceptorError = (error: AxiosError<IMaintenanceError>) => {
    if (
      !isAxiosError<AxiosError<IMaintenanceError>>(error) ||
      error.response?.data?.error?.code !== EServicesErrorCode.REDIRECT_TO_MAINTENANCE
    )
      return Promise.reject(error);

    const payload = error.response?.data.error ?? null;
    const maintenanceErrorHandler = getMaintenanceErrorHandler();
    if (maintenanceErrorHandler) maintenanceErrorHandler(payload);
    const navigate = getNavigate();

    if (navigate) {
      navigate(Path.MAINTENANCE);
      return Promise.reject(error);
    }
  };

  axiosClient.interceptors.response.use(interceptorSuccess, interceptorError);
};

export default createMaintenanceResInterceptor;
